import React from "react";
import { useHistory } from "react-router-dom";

import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";

import { Wrapper, Column, BackButton, Content } from "./styles";

export default function HeaderPage({ activeBackHistory, children, columnContent, borderBottom = false }) {

    let history = useHistory();

    const handleHistory = () => {
        history.goBack();
        return history.goBack();
    };

    return (
        <Wrapper borderBottom={borderBottom}>

            <Column>
                <BackButton
                    type="button"
                    className="goback"
                    onClick={activeBackHistory ? handleHistory : () => history.goBack()}
                >
                    <Icon icon={["far", "chevron-left"]} />
                </BackButton>

                <Content>
                    {children}
                </Content>
            </Column>

            {columnContent && (
                <Column widthSize={columnContent && ("auto")}>
                    {columnContent}
                </Column>
            )}
        </Wrapper>
    )
}
